//external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

// components
import { MapTick } from './MapTick'

const YouAreHereWrapper = styled.div`
	bottom: 4rem;
	left: -5rem;
	position: absolute;
	width: 10rem;
	z-index: 999;
`

const YouAreHereText = styled.div`
	background-color: #fff;
	border-color: ${({ theme }) => theme.colors.teal};
	border-radius: 0.5rem;
	border-style: solid;
	border-width: 0.25rem;
	color: ${({ theme }) => theme.colors.text};
	font-size: 1.25rem;
	padding: 0.5rem;
	text-align: center;
`

MapYouAreHereBox.propTypes = {
	innerTickBorderColor: string,
	tickBorderColor: string,
}

export function MapYouAreHereBox({ tickBorderColor, innerTickBorderColor }) {
	return (
		<YouAreHereWrapper>
			<MapTick tickBorderColor={tickBorderColor} innerTickBorderColor={innerTickBorderColor}>
				<YouAreHereText>You are here!</YouAreHereText>
			</MapTick>
		</YouAreHereWrapper>
	)
}
